import Vue from 'vue';
import Axios from 'axios';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
// import { VueMasonryPlugin } from 'vue-masonry';

// import Viewer from 'v-viewer';
// import 'viewerjs/dist/viewer.css';

import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import config from './config';

declare module 'vue/types/vue' {
  interface Vue {
    $session: any
  }
}

// const VueSocketIO = require('vue-socket.io');

const VueSplide = require('@splidejs/vue-splide');

Vue.use(VueSplide);

const { VueMasonryPlugin } = require('vue-masonry');

Vue.use(VueMasonryPlugin);

// Vue.use(new VueSocketIO({
//   debug: false,
//   connection: config.socketUri,
//   vuex: {
//     store,
//     actionPrefix: 'SOCKET_',
//     mutationPrefix: 'SOCKET_',
//   },
// }));

// Vue.use(Viewer);

Vue.use(PerfectScrollbar);

Vue.config.productionTip = true;
Vue.use(require('vue-session'), { persist: true });
Vue.use(require('vue-moment'));

Vue.use(require('vue-timeago'), {
  name: 'Timeago',
});

const fSubstr = (text: string, length: number, clamp = '') => {
  if (!text) return '';
  const c = (text.length > length) ? clamp : '';
  return `${text.substr(0, length)}${c}`;
};
Vue.filter('substr', fSubstr);

Axios.defaults.headers.common = {
  Key: config.apiKey,
  Authorization: Vue.prototype.$session.get('jwt'),
};

Vue.prototype.$http = Axios;
Vue.prototype.$config = config;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
